import { UserCredentials, userActionTypes, DefaultUserAction } from './userTypes'
import { ILoginResponse } from '../../types/auth'

// LOGIN
export const autoLogin = (): DefaultUserAction => ({
  type: userActionTypes.AUTO_LOGIN,
})
export const login = (userCredentials: UserCredentials): DefaultUserAction => ({
  type: userActionTypes.LOGIN,
  payload: userCredentials,
})
export const loginSuccess = (user: ILoginResponse): DefaultUserAction => ({
  type: userActionTypes.LOGIN_SUCCESS,
  payload: user,
})
export const loginFailure = (): DefaultUserAction => ({
  type: userActionTypes.LOGIN_FAILURE,
})

export const logout = (): DefaultUserAction => ({
  type: userActionTypes.LOGOUT,
})
export const logoutSuccess = (): DefaultUserAction => ({
  type: userActionTypes.LOGOUT_SUCCESS,
})
export const logoutFailure = (): DefaultUserAction => ({
  type: userActionTypes.LOGOUT_FAILURE,
})
